export interface Question {
  id: number;
  text: string;
  answer1?: Answer;
  answer2?: Answer;
  answer3?: Answer;
}

export interface Answer {
  text: string;
  correct: boolean;
  additionalText?: string;
}

export const QuestionLibrary: Question[] = [
  {
    id: 0,
    text: "You wake up, ready to begin your journey to find the treasure! What do you eat for the most important meal of the day?",
    answer1: {
      text: "A nice, cold, refreshing Smirnoff Ice Smoothie!",
      correct: false,
      additionalText:
        "Man, you crave an ice first thing in the morning? Well, if you say so...",
    },
    answer2: {
      text: "I don't believe that breakfast is the most important meal of the day, so I'm right out the door sans nutrition.",
      correct: false,
      additionalText:
        "Well, that's a decision... I hope you enjoy consuming ices on an empty stomach!",
    },
    answer3: {
      text: "A New York, Long Island style BAGEL.",
      correct: true,
    },
  },
  {
    id: 1,
    text: "Okay, time to hit the road! What's your gait like? How are you putting one foot in front of the other?",
    answer1: {
      text: "Skip",
      correct: false,
      additionalText:
        "Joyfully, you skip on forward, hoping maybe to pass over a question? It doesn't work, and you fall on your face.",
    },
    answer2: {
      text: "March",
      correct: true,
    },
    answer3: {
      text: "Sprint",
      correct: false,
      additionalText:
        "Dude! Slow down, you don't know how many questions are in this test!",
    },
  },
  {
    id: 2,
    text: "You've been on the road for quite some time, and you're feeling parched! How do you quench your thirst?",
    answer1: {
      text: "An IV.",
      correct: true,
    },
    answer2: {
      text: "DRINK SOME WATER YOU NERD.",
      correct: false,
      additionalText:
        "You go find a glass bottle of water and immediately down it. Oh no, you didn't look clearly, and it was actually an ice!",
    },
    answer3: {
      text: "Hydration schmydration, we move on.",
      correct: false,
      additionalText:
        "C'mon man you know better than this, didn't you see what happened when you skipped breakfast?",
    },
  },
  {
    id: 3,
    text: "You come across a massive gorge in front of your path! How do you cross it?",
    answer1: {
      text: "Take the rickety bridge",
      correct: false,
      additionalText:
        "You attempt the rickety bridge and it breaks underneath you! You start falling... falling... falling... and then black in, at a Secret Santa party, and you've been handed a beverage.",
    },
    answer2: {
      text: "Use Helium balloons to float across.",
      correct: true,
    },
    answer3: {
      text: "Do a big jump!",
      correct: false,
      additionalText:
        "Man, if you're going to jump across this gap, you better carbo-load first. Oh look, an energy drink!",
    },
  },
  {
    id: 4,
    text: "Good thing those balloons were filled with helium! You land on the other side. Man, this journey has been LONG! You're parched! If you had a Smirnoff Ice right now, how many counts would it take for you to drink it?",
    answer1: {
      text: "Under 7",
      correct: false,
      additionalText: "Oh yeah? Prove it, tough guy.",
    },
    answer2: {
      text: "Over 7",
      correct: false,
      additionalText:
        "What are you talking about? There's no number higher than seven! See, we'll show you...",
    },
    answer3: {
      text: "7",
      correct: true,
    },
  },
  {
    id: 5,
    text: "You have reached a treasure chest with a five digit padlock! There is a note on the chest...",
  },
];
